import React, { useEffect } from "react";
import { Form, FormInstance } from "antd";
import { IEditDocument } from "store/document/document-model";
import FormNewDocument from "./form";

interface IEditDocumentProps {
  editDocument: IEditDocument;
  form: FormInstance;
  maskAllowLetters: boolean;
  maskAllowNumbers: boolean;
  maskAllowSpecialCharacters: boolean;
  maskMaxCharacters: number;
  maskMinCharacters: number;
}
interface IDispatchProps {
  isLoading?: boolean;
  documentUpdateFormModified: (...args) => void;
  documentMaskAllowLetterActive: (...args) => void;
  documentMaskAllowNumberActive: (...args) => void;
  documentMaskAllowSpecialCharactersActive: (...args) => void;
  documentMaskMaxCharactersActive: (...args) => void;
  documentMaskMinCharactersActive: (...args) => void;
  documentIdActive: (...args) => void;
}

export type propsEditForm = IEditDocumentProps & IDispatchProps;

const EditForm = ({
  form,
  maskAllowLetters,
  maskAllowNumbers,
  maskAllowSpecialCharacters,
  maskMinCharacters,
  maskMaxCharacters,
  editDocument,
  documentMaskAllowLetterActive,
  documentMaskAllowNumberActive,
  documentMaskAllowSpecialCharactersActive,
  documentMaskMinCharactersActive,
  documentMaskMaxCharactersActive,
  documentUpdateFormModified,
  documentIdActive,
}: propsEditForm) => {
  useEffect(() => {
    if (editDocument?.documentId) {
      form.setFieldsValue(editDocument);
      documentIdActive(editDocument.documentId);
      documentMaskAllowLetterActive(editDocument.maskRules.maskAllowLetters);
      documentMaskAllowNumberActive(editDocument.maskRules.maskAllowNumbers);
      documentMaskAllowSpecialCharactersActive(editDocument.maskRules.maskAllowSpecialCharacters);
      documentMaskMinCharactersActive(editDocument.maskRules.maskMinCharacters);
      documentMaskMaxCharactersActive(editDocument.maskRules.maskMaxCharacters);
    }
  }, [editDocument]);

  return (
    <Form.Provider
      onFormChange={(_, info) => {
        const { changedFields } = info;
        const changedFileldsSize = changedFields?.length || 0;
        if (changedFileldsSize === 1) {
          documentUpdateFormModified(true);
        }
      }}
    >
      <FormNewDocument
        form={form}
        maskAllowLetters={maskAllowLetters}
        maskAllowNumbers={maskAllowNumbers}
        maskAllowSpecialCharacters={maskAllowSpecialCharacters}
        maskMinCharacters={maskMinCharacters}
        maskMaxCharacters={maskMaxCharacters}
        documentMaskAllowLetterActive={documentMaskAllowLetterActive}
        documentMaskAllowNumberActive={documentMaskAllowNumberActive}
        documentMaskAllowSpecialCharactersActive={documentMaskAllowSpecialCharactersActive}
        documentMaskMinCharactersActive={documentMaskMinCharactersActive}
        documentMaskMaxCharactersActive={documentMaskMaxCharactersActive}
      />
    </Form.Provider>
  );
};

export default EditForm;
